import { render, staticRenderFns } from "./MetricEdit.vue?vue&type=template&id=451349bb"
import script from "./MetricEdit.vue?vue&type=script&lang=js"
export * from "./MetricEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports